export default __webpack_public_path__ + "static/media/eyes.c5e57670.svg";